import React from 'react';
import { isEmpty } from 'lodash';

import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { getStatuses } from '../common/global';

import styles from './ACStatus.module.scss';

export default class ACStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getStatusStyles(status) {
    let statusStyles;

    switch (status) {
      case 'active':
        statusStyles = {
          backgroundColor: '#66cdaa',
          color: 'white',
        };
        break;
      case 'inactive':
        statusStyles = {
          backgroundColor: '#ffa000',
          color: 'white',
        };
        break;
      case 'archived':
        statusStyles = {
          backgroundColor: '#d32f2f',
          color: 'white',
        };
        break;
      case 'in progress':
        statusStyles = {
          backgroundColor: '#66cdaa',
          color: 'white',
        };
        break;
      case 'select':
        statusStyles = {
          backgroundColor: '#ffa000',
          color: 'white',
        };
        break;
      default:
        statusStyles = {
          color: 'black',
        };
        break;
    }

    return statusStyles;
  }

  render() {
    const status = this.props.status || '';

    let s = {
      color: 'black',
      borderRadius: '18px',
      fontSize: '12px',
      boxShadow: '0 0',
      textTransform: 'capitalize',
      ...this.getStatusStyles(status),
    };

    let t = status;
    if (this.props.text) {
      t = this.props.text;
    }

    if (this.props.isEditable) {
      let statuses = [];
      let menuItems = [];

      if (!isEmpty(this.props.type)) {
        statuses = getStatuses(this.props.type);
      }

      if (statuses) {
        statuses.forEach((status) => {
          menuItems.push(
            <MenuItem value={status} key={status} className={styles.capitalized}>
              {status}
            </MenuItem>
          );
        });
      }

      return (
        <FormControl className={styles.editableStatus}>
          <Select
            value={this.props.status}
            name="status"
            style={s}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
              },
            }}
            onChange={this.props.onChangeFunc}
          >
            <MenuItem value="select">Select</MenuItem>
            {menuItems}
          </Select>
        </FormControl>
      );
    }

    return (
      <Button variant="contained" style={s}>
        {t}
      </Button>
    );
  }
}
